import type { FaireProductEntity } from "../../entity_types/product";

export const p_ezf2fjapy5: FaireProductEntity = {
  token: "p_ezf2fjapy5",
  type: "product",
  name: "Natural Garter Stitch Cardigan Sweater Baby & Toddler",
  brandToken: "b_e6gi5qy7n8",
  brandName: "Huggalugs",
  imageUrl:
    "https://cdn.faire.com/fastly/1548e4fb934f3e915440ff64cdd31dc2695ae29351a6005bfe8b06ab6b3f18b2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/249dae49b446a2cb4f283e4d4dde6494d061ac84d2b0c8a0613ea89f170285d7.jpeg",
    "https://cdn.faire.com/fastly/731ed8649caff8082ae28b38f1de127355de0391f0943c98b9698bfc8edecb62.jpeg",
    "https://cdn.faire.com/fastly/e7138aa6d05b39df0f0bb8516d02a9224a101ee4864c59adae5d8626b7b90f40.jpeg",
    "https://cdn.faire.com/fastly/ab7eee2ee8d5e16b351c4b3ee3b98381e756fd67aa83f814f5b19749822b405a.jpeg",
    "https://cdn.faire.com/fastly/376fac6e530762a45384c9bacd168f838b113ce3443941bfa300d5598d7ccab1.jpeg",
    "https://cdn.faire.com/fastly/3586c14ee78ac651f0d93e4402b941aa67994d8a75c7666bc625ea2dce578031.jpeg",
  ],
  priceDollars: 31,
  description:
    "This thick and cuddly garter stitch sweater, hand-knit from natural-colored yarn, features charming cable-trimmed raglan sleeves and wooden buttons. It’s warm, soft, and perfect for keeping little ones cozy. The matching knit hat, available separately, makes a delightful gift for any tiny friend!\n\nOur sweaters are partially knit from recycled, sustainable Polyester yarn made from plastic bottles. We are on a mission to help reduce the world's plastic pollution problem ♻\n\n• Hand Knit\n• 60% Acrylic, 40% Recycled Polyester\n• Hand Wash\n• Designed in our Coachella Valley, CA studio",
  tags: [],
  msrpDollars: 62,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:57.519Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
